import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';
import { outstandingAutomaticPaymentRemindersRoutes } from '~/views/outstanding-automatic-payment-reminders/routing/outstanding-automatic-payment-reminders.routes';
import { outstandingRulesRoutes } from '~/views/outstanding-rules/routing/outstanding-rules-routes';
import { recurrencesRoutes } from '~/views/recurrences/routing/recurrences-routes';

const Outstanding = lazyImport(() => import('~/views/outstanding/Outstanding'));
const OutstandingSummary = lazyImport(() => import('~/views/outstanding/summary/OutstandingSummary'));
const PayOutstandingFlows = lazyImport(() => import('~/views/oustanding-flows/PayOutstandingFlows'));
const DownloadXMLOutstandingFlows = lazyImport(() => import('~/views/outstanding/download-xml/DownloadXMLPage'));
const OutstandingRulesRoute = lazyImport(() => import('~/views/outstanding-rules/OutstandingRulesRoute'));
const RecurrencesRoute = lazyImport(() => import('~/views/recurrences/RecurrencesRoute'));

const OutstandingAutomaticPaymentRemindersRoute = lazyImport(
  () => import('~/views/outstanding-automatic-payment-reminders/OutstandingAutomaticPaymentRemindersRoute'),
);

export const outstandingRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={RouteConfig.OutstandingSummary.buildLink()} replace />,
  },
  {
    path: 'flows',
    element: <Navigate to={RouteConfig.OutstandingFlowsOutflow.buildLink()} replace />,
  },
  {
    path: 'flows/:direction',
    element: <Outstanding />,
  },
  {
    path: 'flows/pay',
    element: <PayOutstandingFlows />,
  },
  {
    path: 'flows/download-xml',
    element: <DownloadXMLOutstandingFlows />,
  },
  {
    path: 'recurrences/*',
    element: <RecurrencesRoute />,
    children: recurrencesRoutes,
  },
  {
    path: 'summary',
    element: <OutstandingSummary />,
  },
  {
    path: 'rules/*',
    element: <OutstandingRulesRoute />,
    children: outstandingRulesRoutes,
  },
  {
    path: 'automatic-payment-reminders',
    element: <OutstandingAutomaticPaymentRemindersRoute />,
    children: outstandingAutomaticPaymentRemindersRoutes,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.OutstandingSummary.buildLink()} replace />,
  },
];
